// store/modules/app.js
const defaultUserOptions = {
    darkTheme: false,
    sidebar: {
        isOpen: true,
        expandOnHover: true,
        miniVariant: true
    },
    notifications: {
        isShown: true,
    }
};

const state = {
    showBar: true,
    color: 'primary',
    appTitle: 'UPT App',
    version: process.env.VUE_APP_VERSION,
    userOptions: {
        ...defaultUserOptions, 
        ...JSON.parse(localStorage.getItem('userOptions')) // Combina el default con lo almacenado en localStorage
    }
};

const getters = {
    showBar: state => state.showBar,
    color: state => state.color,
    appTitle: state => state.appTitle,
    version: state => state.version,
    userOptions: state => state.userOptions
};

const mutations = {
    SET_SHOW_BAR(state, showBar) {
        state.showBar = showBar;
    },
    SET_COLOR(state, color) {
        state.color = color;
    },
    SET_APP_TITLE(state, appTitle) {
        state.appTitle = appTitle;
    },
    SET_VERSION(state, version) {
        state.version = version;
    },
    SET_USER_OPTIONS(state, userOptions) {
        state.userOptions = {
            ...state.userOptions, 
            ...userOptions // Fusiona las opciones nuevas con las existentes
        };
    },
    UPDATE_USER_OPTION(state, { key, value }) {
        const keys = key.split('.');
        let option = state.userOptions;

        // Traverse the nested properties to reach the target property
        for (let i = 0; i < keys.length - 1; i++) {
            if (!option[keys[i]]) {
                option[keys[i]] = {}; // Create nested object if it doesn't exist
            }
            option = option[keys[i]];
        }

        // Update the target property
        const finalKey = keys[keys.length - 1];
        option[finalKey] = value;

        console.info('Updated user options:', state.userOptions);

        // Save the entire userOptions object to localStorage for persistence
        localStorage.setItem('userOptions', JSON.stringify(state.userOptions));
    }
};

const actions = {
    setShowBar({ commit }, showBar) {
        commit('SET_SHOW_BAR', showBar);
    },
    setColor({ commit }, color) {
        commit('SET_COLOR', color);
    },
    setAppTitle({ commit }, appTitle) {
        commit('SET_APP_TITLE', appTitle);
    },
    setVersion({ commit }, version) {
        commit('SET_VERSION', version);
    },
    setUserOptions({ commit }, userOptions) {
        commit('SET_USER_OPTIONS', userOptions);
    },
    updateUserOption({ commit }, payload) {
        commit('UPDATE_USER_OPTION', payload);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
